// 日报管理
import axios from '@/libs/api.request'

export const getMenuTreetByUser = (data) => {
  return axios.request({
    url: '/api/sys/getMenuTreetByUser',
    data,
    method: 'post'
  })
}